var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"La ropa","audio2":"../mp3/PrimariaE/06PE.mp3","cover":"../img/5.jpg","name":"Primaria E - Lección #6"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }